export enum General {
  TITLE = 'page_title',
  ERROR_TITLE = 'title_error_title',
}

export enum ErrorMessage {
  NOT_FOUND = 'page_not_found',
  TRY_AGAIN = 'page_try_again'
}
